module.exports = "<form #kanUserBundleForm=\"ngForm\">\n  <mat-dialog-content>\n    <h1>new bundle form</h1>\n  </mat-dialog-content>\n  <mat-dialog-actions>\n    <button mat-dialog-close mat-button>\n      cancel\n    </button>\n    <button mat-button color=\"primary\" [disabled]=\"!kanUserBundleForm.form.valid\">\n      save\n    </button>\n  </mat-dialog-actions>\n</form>\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin/dialogs/user-bundle-dialog/component.html
// module id = ./src/modules/admin/dialogs/user-bundle-dialog/component.html
// module chunks = main